/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFeaturesEnabledData
 */
export interface UpdateFeaturesEnabledData {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFeaturesEnabledData
     */
    smsEnabled?: boolean;
}

/**
 * Check if a given object implements the UpdateFeaturesEnabledData interface.
 */
export function instanceOfUpdateFeaturesEnabledData(value: object): value is UpdateFeaturesEnabledData {
    return true;
}

export function UpdateFeaturesEnabledDataFromJSON(json: any): UpdateFeaturesEnabledData {
    return UpdateFeaturesEnabledDataFromJSONTyped(json, false);
}

export function UpdateFeaturesEnabledDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFeaturesEnabledData {
    if (json == null) {
        return json;
    }
    return {
        
        'smsEnabled': json['smsEnabled'] == null ? undefined : json['smsEnabled'],
    };
}

  export function UpdateFeaturesEnabledDataToJSON(json: any): UpdateFeaturesEnabledData {
      return UpdateFeaturesEnabledDataToJSONTyped(json, false);
  }

  export function UpdateFeaturesEnabledDataToJSONTyped(value?: UpdateFeaturesEnabledData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'smsEnabled': value['smsEnabled'],
    };
}

